import React from 'react';

export const OverlayDispatch = React.createContext(() => {});
